import { css } from 'glamor'

export default {
  button: css({
    backgroundColor: '#ed5d42',
    border: 'none',
    outline: 'none',
    width: '130px',
    height: '50px',
    color: 'white',
    borderRadius: '10px',

    ':hover': {
      backgroundColor: '#e63816',
      border: 'none',
      outline: 'none',
    },

    '&:disabled': css({
      backgroundColor: '#ffc0b4',
    }),
  })
}


// WEBPACK FOOTER //
// ./src/styles/common.js